<template>
  <div id="app">
    <router-view class="app-content"></router-view>
  </div>
</template>

<script>
// import layOut from './layOuts/index.vue'
export default {
  name: "App",
  components: {
    // layOut
  }
};
</script>
<style lang="scss">
  #app {
    background: #F8F9FC;
    &-content {
      // 隐藏滚动条
      &::-webkit-scrollbar {
        width: 0px;
        background-color: #f5f8fa;
        border-radius: 10px;
        padding: 5px 0;
      }
      &:hover::-webkit-scrollbar {
        width: 0px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #d6d8dd;
        overflow: hidden;
      }
    }
  }
</style>
